
















import KisweSelect from '../KisweSelect'
import { computed, defineComponent } from '@vue/composition-api'
import { useCountries, useSizes, useThemes } from '../../../compositions'

export default defineComponent({
  name: 'KisweSelectCountry',
  components: {
    KisweSelect
  },
  props: {
    label: {
      type: String,
      required: false,
      default: null
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    value: {
      type: String,
      required: false,
      default: null
    },
    placeholder: {
      type: String,
      required: false,
      default: null
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    filterable: {
      type: Boolean,
      required: false,
      default: true
    },
    hasLabelEffect: {
      type: Boolean,
      required: false,
      default: false
    },
    popperClass: {
      type: String,
      required: false,
      default: ''
    },
    ...useSizes().props,
    ...useThemes().props
  },
  emits: {
    input (_value: string) { return true }
  },
  setup () {
    const { allCountries } = useCountries()
    const countryOptions = computed(() => Object.values(allCountries.value)
      .map((country) => ({ label: country.name, key: country.code, value: country.code }))
      .sort((a, b) => a.label.toLowerCase() < b.label.toLowerCase() ? -1 : 1))

    return {
      allCountries,
      countryOptions
    }
  },
  computed: {
    selectedCountryCode: {
      get (): string {
        return this.value ?? ''
      },
      set (newVal: string) {
        this.$emit('input', newVal)
      }
    }
  }
})
